import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regresar',
  templateUrl: './regresar.component.html',
  styleUrls: ['./regresar.component.scss'],
})
export class RegresarComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
